import { LayoutType } from "../../../../base/styles";
import clsx from "clsx";

export const SelectLayoutType = ({ title, value, className, onChange }:{
    title: string,
    value?: LayoutType,
    className?: string,
    onChange: (value?: LayoutType) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as LayoutType;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={LayoutType.Grid}>Grid</option>
                <option value={LayoutType.Flex}>Flex</option>
            </select>
        </div>
    )
}